import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserService } from '@app/core/http-services/user.service';
import { GlobalErrorHandlerService } from '@app/core/services';
import { TimeService } from '@app/shared/helpers';
import { DialogService } from '@progress/kendo-angular-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '@app/shared/services/token.service';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { environment } from '@env/environment';
@Component({
  selector: 'app-profile-preference-details',
  templateUrl: './profile-preference-details.component.html',
  styleUrls: ['./profile-preference-details.component.scss'],
})
export class ProfilePreferenceDetailsComponent {
  destroy$: Subject<boolean> = new Subject<boolean>();
  @ViewChild('container', { read: ViewContainerRef })
  public container: ViewContainerRef;
  profileImageUrl: any = null;
  userDetails: any;
  loader: boolean = false;
  currentUserData: any;
  signedUpDate: any;
  latestLogin: any;
  appAssociated: any;
  showBackButton: boolean = true;
  profileRoute: boolean = true;
  organizationName: string;
  showChangePassword: boolean = false;
  constructor(
    private userService: UserService,
    private errorHandler: GlobalErrorHandlerService,
    private timeService: TimeService,
    private dialogService: DialogService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private tokenService: TokenService
  ) {}
  async ngOnInit() {
    let decodedToken: any = this.tokenService.getDecodedToken();
    if (decodedToken?.org_name) {
      this.organizationName = decodedToken.org_name;
    }
    if (this.router.url == '/profile') {
      this.showBackButton = true;
      this.profileRoute = true;
    } else {
      this.profileRoute = false;
      this.showBackButton = false;
    }

    this.userDetails = this.currentUserData = await this.userService.getUserDetails();
    if (this.tokenService.checkSuperAdmin()) {
      let routeParams: any = await this.getRouteParams();
      if (routeParams.userId) {
        this.getProfile(routeParams.userId);
      } else if (this.userDetails?.sub) {
        this.getProfile(this.userDetails?.sub);
      }
    } else {
      this.setProfileData(this.userDetails);
    }
  }

  /**
   * Get user details from auth0 user
   */
  getRouteParams() {
    return new Promise((resolve) => {
      this.activatedRoute.params.subscribe((params) => {
        resolve(params);
      });
    });
  }

  /**
   * Get user profile details
   */
  getProfile(userId) {
    this.loader = true;
    this.userService
      .getUserProfile(userId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          if (response) {
            let connection: any;
            if (response?.identities?.length) {
              connection = response.identities[0].connection;
            }
            if (connection == environment.authMasterDb) {
              this.showChangePassword = true;
            } else {
              this.showChangePassword = false;
            }

            this.currentUserData = response;
            this.setProfileData(response);
          }
          this.loader = false;
        },
        (err) => {
          this.showChangePassword = false;
          this.setProfileData(this.userDetails);
          this.loader = false;
          this.errorHandler.apiErrorHandle(err);
        }
      );
  }

  /**
   * Set user profile data to variable
   */
  setProfileData(response) {
    if (response.last_login) {
      this.latestLogin = this.timeService.convertTimeTolll(response.last_login);
    }
    if (response.created_at) {
      this.signedUpDate = this.timeService.convertTimeTolll(response.created_at);
    }
    if (response?.app_metadata?.apps?.length) {
      let apps: any = [];
      response.app_metadata.apps.forEach((element) => {
        apps.push(element.name);
      });
      this.appAssociated = apps.toString();
    }
    if (response?.picture) {
      this.profileImageUrl = response.picture;
    }
  }

  /**
   * open to create organization modal
   */
  changePasswordModal() {
    const dialog = this.dialogService.open({
      content: ChangePasswordComponent,
      cssClass: `ces-modal-popup ces-modal-popup-md `,
      appendTo: this.container,
    });
    const catInfo = dialog.content.instance;
    catInfo.cancelBtnText = 'Cancel';
    catInfo.confirmBtnText = 'Continue';
    catInfo.confirmType = 'success';
    catInfo.userDetails = { ...this.currentUserData };
  }

  /**
   * Navigate to apps route
   */
  backToApp() {
    this.router.navigate(['/account/apps']);
  }
}
